export const getProductTitle = (
  productName: string | undefined,
  productVariantColorName: string,
) => {
  return `${productName} (${productVariantColorName})`;
};
